<template>
  <div>
    <!-- {{messagesList}} -->

    <div class="tree">
      <div class="template">
        <div class="template__item">
          <div class="template__left">
            <div class="template__item_priority"></div>
            <div class="template__item_from"><strong>{{$t('project_tab_messages_first_to')}}</strong></div>
            <div class="template__item_title"><strong>{{$t('project_tab_messages_first_title')}}</strong></div>
            <div class="template__item_status"><strong>{{$t('project_tab_messages_first_status')}}</strong></div>
            <div class="template__item_create"><strong>{{$t('project_tab_messages_first_createDate')}}</strong></div>
            <div class="template__item_view"><strong>{{$t('project_tab_messages_first_viewDate')}}</strong></div>
          </div>
          <div class="template__item_link"></div>
        </div>
        <div class="template__item" :class="{'font-weight': !(list.isViewed)}" v-for="list in messagesList" :key="list.id">
          <div @click="showItem(list.id)" class="template__left">
            <div class="template__item_priority">
              <el-tag type="success" size="mini" v-html="list.priority.name"></el-tag>
            </div>
            <div class="template__item_from" v-html="list.toCompanyUser.user.fullName"></div>

            <el-tooltip :content="list.subject" placement="top">
              <div class="template__item_title" v-html="reductionStr(list.subject)"></div>
            </el-tooltip>

            <div class="template__item_status" v-html="status(list.actionType)"></div>
            <div class="template__item_create">{{moment(list.createDate * 1000).format("D MMM YY, HH:mm:ss")}}</div>
            <!-- moment(list.createDate * 1000).format("D MMM YY") -->
            <div class="template__item_view"><span v-if="list.viewDate">{{moment(list.viewDate * 1000).format("D MMM YY, HH:mm:ss")}}</span></div>
          </div>
          <div class="template__item_link">
            <el-button @click="deleteVendor(list.id)" type="danger" icon="el-icon-delete" size="mini" plain title="Delete"></el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- [ Modal are you sure ] start -->
    <sweet-modal blocking ref="confirmation" title="Delete message">
        Are you sure you want to delete this message?
        <template slot="box-action">
            <a class="button" @click="deleteVendorConfirm">Ok</a> &nbsp;
            <a class="button" @click="$refs.confirmation.close()">Cancel</a>
        </template>
    </sweet-modal>
    <!-- [ Modal are you sure ] end -->

    <!-- [ Modal info ] start -->
    <sweet-modal blocking ref="info" class="modal" v-on:close="closeModal">
      <h1 class="modal__title">{{$t('project_tab_messages_first_messageInfo')}}</h1>

      <div class="modal__name">
        <div class="label">{{$t('project_tab_messages_first_from')}}</div> {{itemInfo.fullName}}
      </div>
      <div class="modal__date">
        <div class="label">{{$t('project_tab_messages_first_date')}}</div> {{moment(itemInfo.createDate * 1000).format("D MMM YY, HH:mm:ss")}}
      </div>
      <div class="modal__subject">
        <div class="label">{{$t('project_tab_messages_first_subject')}}</div> {{itemInfo.subject}}
      </div>
      <div class="modal__text" v-html="itemInfo.text"></div>
    </sweet-modal>
    <!-- [ Modal info ] end -->
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
export default {
  components: {
    SweetModal,

  },
  props: ['type', 'activeProjectId', 'selectedRow'],
  computed: {
    messagesList() {
      return this.$store.state.messagesList
    },
  },
  data() {
    return {
      moment:moment,

      itemId: null,

      itemInfo: {
        fullName: '',
        createDate: '',
        subject: '',
        text: '',
      },
    }
  },
  methods: {
    reductionStr(str){
      if (str.length > 25) {
        return str.slice(0, 25) + '...'
      } else {
        return str
      }
    },
    status(id) {
      if (id === 1) {
        return 'For Action'
      } else if (id === 2) {
        return 'For Comment'
      } else {
        return 'For Information Only'
      }
    },
    closeModal() {
      if (this.type == 'task') {
        this.$store.dispatch('getMessagesList', {'type': 'task', 'projectId': this.activeProjectId, 'projectTaskId': this.selectedRow.id, 'projectTaskMessageType': '2'})
      } else if (this.type == 'project') {
        this.$store.dispatch('getMessagesList', {'type': 'project', 'projectId': this.activeProjectId, 'projectMessageType': '2'})
      } else if (this.type == 'taskBusinessUnit') {
        this.$store.dispatch('getMessagesList', {'type': 'taskBusinessUnit', 'businessUnitId': this.activeProjectId, 'businessUnitTaskId': this.selectedRow.id, 'projectTaskMessageType': '2'})
      } else if (this.type == 'businessUnit') {
        this.$store.dispatch('getMessagesList', {'type': 'businessUnit', 'businessUnitId': this.activeProjectId, 'projectMessageType': '2'})
      }
    },
    showItem(id) {
      this.itemId = id

      if (this.type == 'task') {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/projectTaskMessages/info?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRow.id}&projectTaskMessageId=${this.itemId}`)
          .then(response => {
            console.log('---/projectTaskMessages/info', response.data.item);
            this.itemInfo.fullName = response.data.item.fromCompanyUser.user.fullName
            this.itemInfo.createDate = response.data.item.createDate
            this.itemInfo.subject = response.data.item.subject
            this.itemInfo.text = response.data.item.text
            loader.hide()
            this.$refs.info.open();

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/projectTaskMessages/view?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRow.id}&projectTaskMessageId=${this.itemId}`)
              .then(response => {
                console.log('---/projectTaskMessages/view', response.data);
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });

          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      } else if (this.type == 'project') {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/projectMessages/info?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectMessageId=${this.itemId}`)
          .then(response => {
            console.log('---/projectMessages/info', response.data.item);
            this.itemInfo.fullName = response.data.item.fromCompanyUser.user.fullName
            this.itemInfo.createDate = response.data.item.createDate
            this.itemInfo.subject = response.data.item.subject
            this.itemInfo.text = response.data.item.text
            loader.hide()
            this.$refs.info.open();

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/projectMessages/view?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectMessageId=${this.itemId}`)
              .then(response => {
                console.log('---/projectMessages/view', response.data);
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });

          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      } else if (this.type == 'taskBusinessUnit') {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/businessUnitTaskMessages/info?companyId=${this.$route.query.companyId}&businessUnitId=${this.activeProjectId}&businessUnitTaskId=${this.selectedRow.id}&businessUnitTaskMessageId=${this.itemId}`)
          .then(response => {
            console.log('---/businessUnitTaskMessages/info', response.data.item);
            this.itemInfo.fullName = response.data.item.fromCompanyUser.user.fullName
            this.itemInfo.createDate = response.data.item.createDate
            this.itemInfo.subject = response.data.item.subject
            this.itemInfo.text = response.data.item.text
            loader.hide()
            this.$refs.info.open();

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/businessUnitTaskMessages/view?companyId=${this.$route.query.companyId}&businessUnitId=${this.activeProjectId}&businessUnitTaskId=${this.selectedRow.id}&businessUnitTaskMessageId=${this.itemId}`)
              .then(response => {
                console.log('---/businessUnitTaskMessages/view', response.data);
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });

          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      } else if (this.type == 'businessUnit') {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/businessUnitMessages/info?companyId=${this.$route.query.companyId}&businessUnitId=${this.activeProjectId}&businessUnitMessageId=${this.itemId}`)
          .then(response => {
            console.log('---/businessUnitMessages/info', response.data.item);
            this.itemInfo.fullName = response.data.item.fromCompanyUser.user.fullName
            this.itemInfo.createDate = response.data.item.createDate
            this.itemInfo.subject = response.data.item.subject
            this.itemInfo.text = response.data.item.text
            loader.hide()
            this.$refs.info.open();

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/businessUnitMessages/view?companyId=${this.$route.query.companyId}&businessUnitId=${this.activeProjectId}&businessUnitMessageId=${this.itemId}`)
              .then(response => {
                console.log('---/businessUnitMessages/view', response.data);
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });

          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      }else if (this.type == 'engagement') {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
                .post(`/api/v1/engagementMessages/info?companyId=${this.$route.query.companyId}&engagementId=${this.activeProjectId}&engagementMessageId=${this.itemId}`)
                .then(response => {
                  console.log('---/engagementMessages/info', response.data.item);
                  this.itemInfo.fullName = response.data.item.fromCompanyUser.user.fullName
                  this.itemInfo.createDate = response.data.item.createDate
                  this.itemInfo.subject = response.data.item.subject
                  this.itemInfo.text = response.data.item.text
                  loader.hide()
                  this.$refs.info.open();

                  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                  axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                  axios
                          .post(`/api/v1/engagementMessages/view?companyId=${this.$route.query.companyId}&engagementId=${this.activeProjectId}&engagementMessageId=${this.itemId}`)
                          .then(response => {
                            console.log('---/engagementMessages/view', response.data);
                          })
                          .catch(error => {
                            console.log('An error occurred:', error);
                          });

                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  loader.hide()
                });
      }else if (this.type == 'taskEngagement') {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
                .post(`/api/v1/engagementTaskMessages/info?companyId=${this.$route.query.companyId}&engagementId=${this.activeProjectId}&engagementTaskId=${this.selectedRow.id}&engagementTaskMessageId=${this.itemId}`)
                .then(response => {
                  console.log('---/engagementTaskMessages/info', response.data.item);
                  this.itemInfo.fullName = response.data.item.fromCompanyUser.user.fullName
                  this.itemInfo.createDate = response.data.item.createDate
                  this.itemInfo.subject = response.data.item.subject
                  this.itemInfo.text = response.data.item.text
                  loader.hide()
                  this.$refs.info.open();

                  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                  axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                  axios
                          .post(`/api/v1/engagementTaskMessages/view?companyId=${this.$route.query.companyId}&engagementId=${this.activeProjectId}&engagementTaskId=${this.selectedRow.id}&engagementTaskMessageId=${this.itemId}`)
                          .then(response => {
                            console.log('---/engagementTaskMessages/view', response.data);
                          })
                          .catch(error => {
                            console.log('An error occurred:', error);
                          });

                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  loader.hide()
                });
      }
    },
    deleteVendorConfirm() {
      if (this.type == 'task') {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/projectTaskMessages/delete?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRow.id}&projectTaskMessageId=${this.itemId}`)
            .then(response => {
                console.log('---/projectTaskMessages/delete', response.data);
                this.$store.dispatch('getMessagesList', {'type': 'task', 'projectId': this.activeProjectId, 'projectTaskId': this.selectedRow.id, 'projectTaskMessageType': '2'})
                this.$refs.confirmation.close();
                this.notification("Success", "Delete message", "success");
                loader.hide()
            })
            .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
            });
      } else if (this.type == 'project') {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/projectMessages/delete?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectMessageId=${this.itemId}`)
            .then(response => {
                console.log('---/projectMessages/delete', response.data);
                this.$store.dispatch('getMessagesList', {'type': 'project', 'projectId': this.activeProjectId, 'projectMessageType': '2'})
                this.$refs.confirmation.close();
                this.notification("Success", "Delete message", "success");
                loader.hide()
            })
            .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
            });
      } else if (this.type == 'engagement') {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
                .post(`/api/v1/engagementMessages/delete?companyId=${this.$route.query.companyId}&engagementId=${this.activeProjectId}&engagementMessageId=${this.itemId}`)
                .then(response => {
                  console.log('---/engagementMessages/delete', response.data);
                  this.$store.dispatch('getMessagesList', {'type': 'engagement', 'engagementId': this.activeProjectId, 'projectMessageType': '2'})
                  this.$refs.confirmation.close();
                  this.notification("Success", "Delete message", "success");
                  loader.hide()
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  loader.hide()
                });
      }else if (this.type == 'taskBusinessUnit') {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/businessUnitTaskMessages/delete?companyId=${this.$route.query.companyId}&businessUnitId=${this.activeProjectId}&businessUnitTaskId=${this.selectedRow.id}&businessUnitTaskMessageId=${this.itemId}`)
            .then(response => {
                console.log('---/businessUnitTaskMessages/delete', response.data);
                this.$store.dispatch('getMessagesList', {'type': 'taskBusinessUnit', 'businessUnitId': this.activeProjectId, 'businessUnitTaskId': this.selectedRow.id, 'projectTaskMessageType': '2'})
                this.$refs.confirmation.close();
                this.notification("Success", "Delete message", "success");
                loader.hide()
            })
            .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
            });
      } else if (this.type == 'taskEngagement') {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
                .post(`/api/v1/engagementTaskMessages/delete?companyId=${this.$route.query.companyId}&engagementId=${this.activeProjectId}&engagementTaskId=${this.selectedRow.id}&engagementTaskMessageId=${this.itemId}`)
                .then(response => {
                  console.log('---/engagementTaskMessages/delete', response.data);
                  this.$store.dispatch('getMessagesList', {'type': 'taskEngagement', 'engagementId': this.activeProjectId, 'engagementTaskId': this.selectedRow.id, 'projectTaskMessageType': '2'})
                  this.$refs.confirmation.close();
                  this.notification("Success", "Delete message", "success");
                  loader.hide()
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  loader.hide()
                });
      }else if (this.type == 'businessUnit') {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/businessUnitMessages/delete?companyId=${this.$route.query.companyId}&businessUnitId=${this.activeProjectId}&businessUnitMessageId=${this.itemId}`)
            .then(response => {
                console.log('---/businessUnitMessages/delete', response.data);
                this.$store.dispatch('getMessagesList', {'type': 'businessUnit', 'businessUnitId': this.activeProjectId, 'projectMessageType': '2'})
                this.$refs.confirmation.close();
                this.notification("Success", "Delete message", "success");
                loader.hide()
            })
            .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
            });
      }
    },
    deleteVendor(id) {
      this.itemId = id
      // this.$refs.confirmation.open();

      if (this.type == 'task') {
        this.$confirm('This will permanently delete the msg. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed'
          });

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .post(`/api/v1/projectTaskMessages/delete?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRow.id}&projectTaskMessageId=${this.itemId}`)
              .then(response => {
                  console.log('---/projectTaskMessages/delete', response.data);
                  this.$store.dispatch('getMessagesList', {'type': 'task', 'projectId': this.activeProjectId, 'projectTaskId': this.selectedRow.id, 'projectTaskMessageType': '2'})
                  this.$refs.confirmation.close();
                  this.notification("Success", "Delete message", "success");
                  loader.hide()
              })
              .catch(error => {
                  console.log('An error occurred:', error);
                  loader.hide()
              });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      } else if (this.type == 'project') {
        this.$confirm('This will permanently delete the msg. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed'
          });

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .post(`/api/v1/projectMessages/delete?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectMessageId=${this.itemId}`)
              .then(response => {
                  console.log('---/projectMessages/delete', response.data);
                  this.$store.dispatch('getMessagesList', {'type': 'project', 'projectId': this.activeProjectId, 'projectMessageType': '2'})
                  this.$refs.confirmation.close();
                  this.notification("Success", "Delete message", "success");
                  loader.hide()
              })
              .catch(error => {
                  console.log('An error occurred:', error);
                  loader.hide()
              });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      } else if (this.type == 'engagement') {
        this.$confirm('This will permanently delete the msg. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed'
          });

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .post(`/api/v1/engagementMessages/delete?companyId=${this.$route.query.companyId}&engagementId=${this.activeProjectId}&engagementMessageId=${this.itemId}`)
                  .then(response => {
                    console.log('---/engagementMessages/delete', response.data);
                    this.$store.dispatch('getMessagesList', {'type': 'engagement', 'engagementId': this.activeProjectId, 'projectMessageType': '2'})
                    this.$refs.confirmation.close();
                    this.notification("Success", "Delete message", "success");
                    loader.hide()
                  })
                  .catch(error => {
                    console.log('An error occurred:', error);
                    loader.hide()
                  });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      }else if (this.type == 'taskBusinessUnit') {
        this.$confirm('This will permanently delete the msg. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed'
          });

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .post(`/api/v1/businessUnitTaskMessages/delete?companyId=${this.$route.query.companyId}&businessUnitId=${this.activeProjectId}&businessUnitTaskId=${this.selectedRow.id}&businessUnitTaskMessageId=${this.itemId}`)
              .then(response => {
                  console.log('---/businessUnitTaskMessages/delete', response.data);
                  this.$store.dispatch('getMessagesList', {'type': 'taskBusinessUnit', 'businessUnitId': this.activeProjectId, 'businessUnitTaskId': this.selectedRow.id, 'projectTaskMessageType': '2'})
                  this.$refs.confirmation.close();
                  this.notification("Success", "Delete message", "success");
                  loader.hide()
              })
              .catch(error => {
                  console.log('An error occurred:', error);
                  loader.hide()
              });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      } else if (this.type == 'taskEngagement') {
        this.$confirm('This will permanently delete the msg. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed'
          });

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .post(`/api/v1/engagementTaskMessages/delete?companyId=${this.$route.query.companyId}&engagementId=${this.activeProjectId}&engagementTaskId=${this.selectedRow.id}&engagementTaskMessageId=${this.itemId}`)
                  .then(response => {
                    console.log('---/engagementTaskMessages/delete', response.data);
                    this.$store.dispatch('getMessagesList', {'type': 'taskEngagement', 'engagementId': this.activeProjectId, 'engagementTaskId': this.selectedRow.id, 'projectTaskMessageType': '2'})
                    this.$refs.confirmation.close();
                    this.notification("Success", "Delete message", "success");
                    loader.hide()
                  })
                  .catch(error => {
                    console.log('An error occurred:', error);
                    loader.hide()
                  });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      }else if (this.type == 'businessUnit') {
        this.$confirm('This will permanently delete the msg. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed'
          });

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .post(`/api/v1/businessUnitMessages/delete?companyId=${this.$route.query.companyId}&businessUnitId=${this.activeProjectId}&businessUnitMessageId=${this.itemId}`)
              .then(response => {
                  console.log('---/businessUnitMessages/delete', response.data);
                  this.$store.dispatch('getMessagesList', {'type': 'businessUnit', 'businessUnitId': this.activeProjectId, 'projectMessageType': '2'})
                  this.$refs.confirmation.close();
                  this.notification("Success", "Delete message", "success");
                  loader.hide()
              })
              .catch(error => {
                  console.log('An error occurred:', error);
                  loader.hide()
              });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      }
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.tree {
  width: 100%;
  overflow-y: auto;
  font-size: 12px;
  overflow: auto;
  .template {
    border-bottom: 1px dashed #d9d9d9;
    &:last-child {
      border-bottom: none;
    }

    .font-weight {
      font-weight: bold;
    }

    &__item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 40px;
      padding: 10px 0;
      border-bottom: 1px dashed #d9d9d9;
      &:hover {
        background: #f7f7f7;
        cursor: pointer;
        &:first-child {
          background: none;
          cursor: auto;
        }
      }

      &_priority {
        width: 70px;
        padding-left: 3px;
        text-align: center;
        .el-tag {
          width: 70px;
          text-align: center;
        }
      }

      &_from {
        width: 170px;
        text-align: center;
      }

      &_title {
        width: 150px;
        text-align: center;
      }

      &_status {
        width: 160px;
        text-align: center;
      }

      &_create {
        width: 150px;
        text-align: center;
        margin-right: 15px;
      }

      &_view {
        width: 150px;
        text-align: center;
      }

      &_link {
        width: 50px;
        text-align: center;
      }
    }
    &__left {
      display: flex;
      justify-content: space-between;
      width: 90%;
    }
  }
}

// [ Modal ] start
.modal {
  .label {
    display: inline-block;
    width: 100px;
    font-weight: bold;
  }
  &__title {
    text-align: center;
  }
  &__btn {
    text-align: right;
  }
  &__name {
    background: #f7f7f7;
    padding: 5px;
  }
  &__date {
    padding: 5px;
  }
  &__subject {
    background: #f7f7f7;
    margin-bottom: 10px;
    padding: 5px;
  }
  &__text {
    box-sizing: border-box;
    padding: 5px;
    border: 1px solid #DCDCDC;
    border-radius: 5px;
    min-height: 70px;
    max-height: 300px;
    overflow-y: scroll;
  }
}
.button{
  cursor: pointer;
}
// [ Modal ] end
</style>
